/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React from 'react';
import {Dialog, Snackbar} from '@dvrd/dvr-controls';

import {AppContext} from "./appContext";

export class PopupController extends React.Component {
    declare context: React.ContextType<typeof AppContext>;
    static contextType = AppContext;

    renderUserIndependantComponents = () => {
        return (
            <>
                <Dialog/>
                <Snackbar/>
            </>
        )
    };

    renderUserDependantComponents = () => {
        const {user} = this.context.userContext;
        if (user !== null && user.id !== null)
            return (
                <>
                </>
            );
        return null;
    };

    render = () => {
        return <>
            {this.renderUserDependantComponents()}
            {this.renderUserIndependantComponents()}
        </>
    };
}